import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {TextInputV2} from '../../../components/TextInputV2'
import {Selection} from '../../../components/Selection'
import {ORDER_STATUS, SECTOR_OPTIONS, PRODUCT_TYPE, PAYMENT_TYPE} from '../../../constants'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {setFilter, soSelector} from '../../../redux/slices/soSlices'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {TRowFilter} from '../../../components/Table/Table'

export const RowFilterTableSO = memo(() => {
  const {t} = useTranslation()
  const {filter} = useAppSelector(soSelector)
  const dispatch = useAppDispatch()
  const {salesOrgOptions} = useSalesOrganization()

  return (
    <TRowFilter>
      <td>
        <div>&nbsp;</div>
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-soNomor')}
          value={filter?.so_number ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, so_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-pelanggan')}
          value={filter?.customer_name ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, customer_name: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('order-no')}
          value={filter?.po_number ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, po_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sip-number')}
          value={filter?.sip_number ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, sip_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-soNomor')}
          value={filter?.sap_number ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, sap_number: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-kodeBooking')}
          value={filter?.booking_code ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, booking_code: target.value}))}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Sales Org')}
          data={salesOrgOptions}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => dispatch(setFilter({...filter, sales_org_code}))}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Sektor')}
          data={SECTOR_OPTIONS}
          value={filter?.sector_id ?? ''}
          onChange={(sector_id) => dispatch(setFilter({...filter, sector_id}))}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('order-tanggal')}
          startDate={filter?.from_date ?? ''}
          endDate={filter?.to_date ?? ''}
          onChange={({startDate, endDate}) =>
            dispatch(setFilter({...filter, from_date: startDate, to_date: endDate}))
          }
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('sub-order-jenis')}
          value={filter?.product_type ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, product_type: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-kuantum')}
          value={filter?.total_quantum_so ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, total_quantum_so: target.value}))}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Total Price')}
          value={filter?.total_price_so ?? ''}
          onChange={({target}) => dispatch(setFilter({...filter, total_price_so: target.value}))}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Metode Pembayaran')}
          data={PAYMENT_TYPE}
          value={filter?.payment_type ?? ''}
          onChange={(payment_type) => dispatch(setFilter({...filter, payment_type}))}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Status')}
          data={ORDER_STATUS}
          value={filter?.status ?? ''}
          onChange={(status) => dispatch(setFilter({...filter, status}))}
        />
      </td>
      <td>
        <div>&nbsp;</div>
      </td>
    </TRowFilter>
  )
})
